/* @flow */
import { withRouter } from 'react-router';

import Button from 'components/Button.jsx';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import Text from 'components/Text.jsx';
import Time from 'components/Time.jsx';
import ReuseClassConfirmDialog from 'groups/components/ReuseClassConfirmDialog.jsx';
import RestoreClassConfirmDialog from 'groups/components/RestoreClassConfirmDialog.jsx';

import './styles/ArchivedClassesListItem.scss';

export class ArchivedClassesListItem extends React.Component {
  props: {
    archivedClass: Group,
    canCreateGroups: bool,
    router: Object,
  };

  handleReuseCompletion(newGroup: Group) {
    this.props.router.push('/classes/' + newGroup.getCode());
  }

  renderReuseDialog() {
    const subText = `A new class will be created with the code @${this.props.archivedClass.getCode()}, and this class will be archived with an automatically generated code.`;
    return (
      <ReuseClassConfirmDialog
        group={this.props.archivedClass}
        onActionCompletion={newGroup => this.handleReuseCompletion(newGroup)}
        subText={subText}
      />
    );
  }

  handleRestoreCompletion(newGroup: Group) {
    this.props.router.push('/classes/' + newGroup.getCode());
  }

  renderRestoreDialog() {
    return (
      <RestoreClassConfirmDialog
        group={this.props.archivedClass}
        onActionCompletion={newGroup => this.handleRestoreCompletion(newGroup)}
      />
    );
  }

  renderAvatar() {
    return (
      <GroupAvatar
        className="ArchivedClassesListItem-avatar"
        group={this.props.archivedClass}
      />
    );
  }

  renderClassName() {
    return (
      <Text size="xsmall" weight="semibold" color="pitch">
        <GroupName group={this.props.archivedClass} />
      </Text>
    );
  }

  renderSubtext() {
    return (
      <div className="ArchivedClassesListItem-subtext">
        @{this.props.archivedClass.getCode()}&nbsp;&bull;&nbsp;
        <Time
          className="ArchivedClassesListItem-date"
          date={this.props.archivedClass.getArchivedDate()}
          month="numeric"
          day="numeric"
          year="numeric"
        />
      </div>
    );
  }

  renderRestoreButton() {
    return (
      <ModalTrigger modal={this.renderRestoreDialog()}>
        <Button
          color="brand"
          level="secondary"
          size="small">
          Restore
        </Button>
      </ModalTrigger>
    );
  }

  renderReuseButton() {
    return (
      <ModalTrigger modal={this.renderReuseDialog()}>
        <Button
          color="brand"
          level="secondary"
          size="small">
          Reuse class code
        </Button>
      </ModalTrigger>
    );
  }

  renderButtons() {
    if (!this.props.canCreateGroups) {
      return null;
    }

    return (
      <span className="ArchivedClassesListItem-buttons">
        {this.renderRestoreButton()}
        {this.renderReuseButton()}
      </span>
    );
  }

  render() {
    return (
      <FlexibleBlock className="ArchivedClassesListItem" flex="left">
        <FlexibleBlock flex="right">
          {this.renderAvatar()}
          <div className="ArchivedClassesListItem-info">
            {this.renderClassName()}
            {this.renderSubtext()}
          </div>
        </FlexibleBlock>
        {this.renderButtons()}
      </FlexibleBlock>
    );
  }
}

export default withRouter(ArchivedClassesListItem);



// WEBPACK FOOTER //
// ./src/settings/components/ArchivedClassesListItem.jsx